export default __webpack_public_path__ + "static/media/castle.4d11a6b3.png";